import React from "react"

const DiscountIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
    >
      <path d="M8.383 14.267q-.4.4-.95.4t-.95-.4L1.717 9.5a1.28 1.28 0 0 1-.384-.942q0-.558.384-.941l5.866-5.884a1.38 1.38 0 0 1 .967-.4h4.767q.55 0 .941.392.392.391.392.942v4.766q0 .284-.108.534-.11.249-.292.433zm3.267-8.934a.96.96 0 0 0 .708-.291.96.96 0 0 0 .292-.709.96.96 0 0 0-.292-.708.96.96 0 0 0-.708-.292.97.97 0 0 0-.708.292.96.96 0 0 0-.292.708q0 .417.292.709.291.291.708.291m-4.217 8 5.884-5.9V2.667H8.55l-5.883 5.9z"></path>
    </svg>
  )
}

export { DiscountIcon }
